import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { listClientProfiles } from "services/tenantUserAdminService";
import { TC } from "../../../tokens/text";

export default function ClientStatsWidget({ tenantId }) {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tenantId) return;
    setLoading(true);
    listClientProfiles({ tenantId })
      .then((res) => setProfiles((res.clientProfiles || []).filter(p => p.status !== "archived")))
      .catch(() => setProfiles([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  const companies   = profiles.filter((p) => p.clientType !== "individual").length;
  const individuals = profiles.filter((p) => p.clientType === "individual" && !p.linkedCompanyClientId).length;
  const directors   = profiles.filter((p) => p.clientType === "individual" && !!p.linkedCompanyClientId).length;
  const total       = companies + individuals;

  const stats = [
    { label: "Total Clients",  value: total,       color: TC.white },
    { label: "Companies",      value: companies,   color: TC.linkHover },
    { label: "Individuals",    value: individuals, color: "#4caf50" },
    { label: "Directors",      value: directors,   color: "#ff9800" },
  ];

  return (
    <VuiBox display="flex" flexWrap="wrap" gap={1.5} p={2} alignItems="stretch" height="100%">
      {stats.map(({ label, value, color }) => (
        <VuiBox
          key={label}
          flex="1 1 120px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={1.5}
          sx={{
            background: "#f4f8ff",
            border: "1px solid #d8e6f7",
            borderRadius: "12px",
            minWidth: 90,
          }}
        >
          <VuiTypography
            variant="caption"
            color="text"
            sx={{ textTransform: "uppercase", letterSpacing: "0.08em", fontSize: "0.65rem", mb: 0.5, textAlign: "center" }}
          >
            {label}
          </VuiTypography>
          <VuiTypography variant="h3" fontWeight="bold" sx={{ color, lineHeight: 1 }}>
            {loading ? <CircularProgress size={20} sx={{ color }} /> : value}
          </VuiTypography>
        </VuiBox>
      ))}
    </VuiBox>
  );
}

